for (var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r = {}, o = 0; o < 66; o++) r[a.charAt(o)] = o;
var t = {
  itoc: a,
  ctoi: r
};
export { t as b };